import { Box, Typography } from "@material-ui/core";
import React from "react";

import { InvestmentStyleDiagnosisRequestExplanationStylesEnum as ExplanationEnum } from "@/api/generated";
import {
  DIAGNOSIS_QUESTION_TEXT,
  EXPLANATION_OPTIONS,
  MEETING_FREE_TEXT_PLACEHOLDER,
} from "@/constants/investmentStyleDiagnosisQuestions";

import { DiagnosisInvestmentStyleCheckboxList } from "../DiagnosisInvestmentStyleCheckboxList";
import { DiagnosisInvestmentStyleFreeText } from "../DiagnosisInvestmentStyleFreeText";

import { useStepStyles } from "./stepStyles";

type ExplanationStepProps = {
  explanationStyles: ExplanationEnum[];
  onExplanationStylesChange: (next: ExplanationEnum[]) => void;
  meetingFreeText: string;
  onMeetingFreeTextChange: (value: string) => void;
};

const ExplanationStep: React.FC<ExplanationStepProps> = ({
  explanationStyles,
  onExplanationStylesChange,
  meetingFreeText,
  onMeetingFreeTextChange,
}) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>希望する説明の仕方</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[17]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleCheckboxList
          options={EXPLANATION_OPTIONS}
          selected={explanationStyles}
          onChange={onExplanationStylesChange}
        />
      </Box>
      <Box className={classes.divider} />
      <Typography className={classes.subHeading}>プランナーに伝えておきたいこと</Typography>
      <Typography className={classes.subDescription}>{DIAGNOSIS_QUESTION_TEXT[18]}</Typography>
      <DiagnosisInvestmentStyleFreeText
        value={meetingFreeText}
        placeholder={MEETING_FREE_TEXT_PLACEHOLDER}
        onChange={onMeetingFreeTextChange}
      />
    </>
  );
};

export default ExplanationStep;
